import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import NotFoundPage from '../pages/NotFoundPage';

interface AdminRouteProps {
  children: React.ReactNode;
  permission?: 'users' | 'error-reports' | 'sign-in-access';
}

/**
 * UI-level route concealment for admin-only pages.
 *
 * This guard is not an authorization boundary. Admin API endpoints must still
 * authorize every request using the role/permissions from the signed token.
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children, permission = 'users' }) => {
  const { canImpersonate, canManageErrorReports, canManageSignInAccess } = useAuth();
  const allowed = permission === 'error-reports'
    ? canManageErrorReports
    : permission === 'sign-in-access'
      ? canManageSignInAccess
      : canImpersonate;

  if (!allowed) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};

export default AdminRoute;